var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8087 38.2561H68.7869C68.4912 38.2561 68.2064 38.1436 67.9906 37.9441L55.7391 26.5851C55.2639 26.1443 55.2367 25.4024 55.6757 24.929C56.1164 24.4537 56.8584 24.4265 57.3318 24.8655L69.4581 36.1066C69.7737 36.317 69.9805 36.6761 69.9805 37.0825C69.9805 37.7319 69.4563 38.2561 68.8087 38.2561ZM45.2563 16.4433C44.9715 16.4433 44.6849 16.3399 44.46 16.1313C40.9536 12.8825 38.4903 10.5969 38.4903 10.5969C38.1728 10.3031 38.044 9.85865 38.1529 9.43963C38.2617 9.0206 38.5937 8.69772 39.0145 8.59614L39.234 8.54353C39.858 8.39479 40.4856 8.77572 40.6434 9.39609C41.5613 10.2468 43.5403 12.0826 46.0544 14.4117C46.5297 14.8525 46.5569 15.5944 46.1179 16.0678C45.8857 16.3163 45.5719 16.4433 45.2563 16.4433Z",
    fill: "#D7AE5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9297 69.4888C62.3238 69.4888 61.8105 69.0226 61.7615 68.4095C61.7416 68.1555 61.8032 67.9143 61.9248 67.7129V37.0753C61.9248 36.4277 62.449 35.9034 63.0966 35.9034C63.7442 35.9034 64.2684 36.4277 64.2684 37.0753V68.3043C64.2684 68.9156 63.7986 69.4235 63.1891 69.4725L63.0222 69.4852C62.9914 69.487 62.9605 69.4888 62.9297 69.4888Z",
    fill: "#D7AE5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6602 25.4298C57.0144 25.4298 56.4884 24.9074 56.4884 24.2598L56.4666 13.9257C55.9714 13.7806 55.6159 13.3198 55.6249 12.7793C55.6376 12.1317 56.1764 11.6111 56.8185 11.6292L57.6584 11.6438C58.2969 11.6546 58.8084 12.1752 58.8084 12.8138L58.832 24.2544C58.8338 24.9019 58.3096 25.428 57.662 25.4298C57.662 25.4298 57.662 25.4298 57.6602 25.4298Z",
    fill: "#D7AE5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1821 26.1844C56.1821 26.9701 56.8183 27.6062 57.6039 27.6062C58.3891 27.6062 59.0275 26.9706 59.0275 26.1844V12.6686C59.0275 11.883 58.3914 11.2468 57.6057 11.2468H49.0547C48.2691 11.2468 47.6329 11.883 47.6329 12.6686V18.2103C47.6329 18.9959 48.2691 19.6321 49.0547 19.6321C49.8404 19.6321 50.4766 18.9959 50.4766 18.2103V14.0905H56.1821V26.1844Z",
    fill: "#987225",
    stroke: "#987225",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9502 68.3117V44.661H45.2767V68.3135C45.2767 69.0991 45.9128 69.7353 46.6985 69.7353C47.4845 69.7353 48.1199 69.0971 48.1221 68.3142V68.3135V43.2392C48.1221 42.4535 47.4859 41.8174 46.7003 41.8174H31.5284C30.7427 41.8174 30.1066 42.4535 30.1066 43.2392V68.3117C30.1066 69.0973 30.7427 69.7335 31.5284 69.7335C32.314 69.7335 32.9502 69.0973 32.9502 68.3117Z",
    fill: "#987225",
    stroke: "#987225",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23174 36.0345L8.2315 36.0347C7.65324 36.5646 7.61072 37.4646 8.14171 38.0441C8.42145 38.3501 8.8068 38.5061 9.19129 38.5061C9.53429 38.5061 9.87793 38.3828 10.1506 38.1344L10.1508 38.1341L39.1058 11.6678L67.6465 38.1275L67.6468 38.1278C68.2231 38.66 69.1211 38.6273 69.6559 38.0507L69.6559 38.0506C70.1888 37.4759 70.1556 36.5758 69.5791 36.0412L69.5791 36.0412L40.0791 8.69255C39.5372 8.18804 38.6984 8.18623 38.1528 8.68568L8.23174 36.0345Z",
    fill: "#D7AE5B",
    stroke: "#D7AE5B",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8073 69.7352H63.1074L64.2775 68.3116H64.5275V68.3109V33.7557C64.5275 32.9701 63.8913 32.3339 63.1056 32.3339C62.32 32.3339 61.6838 32.9701 61.6838 33.7557V66.8898H16.2291V32.7018C16.2291 31.9162 15.593 31.28 14.8073 31.28C14.0217 31.28 13.3855 31.9162 13.3855 32.7018V68.3134C13.3855 69.099 14.0217 69.7352 14.8073 69.7352Z",
    fill: "#D7AE5B",
    stroke: "#D7AE5B",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4084 59.5254H72.1072",
    stroke: "#987225",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01917 68.4852H76.0913",
    stroke: "#987225",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7578 60.5254L62.7578 67.5732",
    stroke: "#987225",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1072 59.5254L72.1072 68.4852",
    stroke: "#987225",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4084 59.5254L53.4084 68.4852",
    stroke: "#987225",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseFarm);
export default __webpack_public_path__ + "static/media/houseFarm.363136ae9015a7ff27f18174c38d4256.svg";
export { ForwardRef as ReactComponent };